import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import prospectTable from './prospectTable/reducers'
import auth from './auth/reducers'
import localeReducer from './locale/reducers'

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  user,
  prospectTable,
  auth,
  locale: localeReducer,
})

export default createRootReducer
